<div class="be-list-page">
  <div class="page-wrapper">
    <button routerLink="/" class="btn btn-ghost btn-default back btn-sm">
      <i class="fas fa-chevron-left"></i>
      <span i18n="@@Back">Back</span>
    </button>
    <h2 i18n="@@Manage businesses">Manage businesses</h2>
    <div class="list-table business-entities">
      <div class="heading-container">
        <div class="list-column business sortable">
          <button type="button" i18n="@@Name" (click)="orderBy('name')">
            Name
          </button>
          <i
            class="sortorder far fa-sort-alpha-down"
            *ngIf="orderings.name === ordering"
            [ngClass]="{ 'fa-sort-alpha-down-alt': orderings.name.isReverse }"
          ></i>
        </div>
        <div class="list-column number-files">
          <span i18n="@@Files">Files</span>
        </div>
        <div class="list-column date-column sortable">
          <button
            type="button"
            i18n="@@Updated at"
            (click)="orderBy('updated_at')"
          >
            Updated at
          </button>
          <i
            class="sortorder far fa-sort-alpha-down"
            *ngIf="orderings.updated_at === ordering"
            [ngClass]="{
              'fa-sort-alpha-down-alt': orderings.updated_at.isReverse
            }"
          ></i>
        </div>
        <div class="list-column date-column sortable">
          <button
            type="button"
            i18n="@@Created at"
            (click)="orderBy('created_at')"
          >
            Created at
          </button>
          <i
            class="sortorder far fa-sort-alpha-down"
            *ngIf="orderings.created_at === ordering"
            [ngClass]="{
              'fa-sort-alpha-down-alt': orderings.created_at.isReverse
            }"
          ></i>
        </div>
        <div class="list-column actions-column"></div>
      </div>
      <div class="list-container">
        <div
          class="list-item"
          *ngFor="
            let be of beList
              | paginate
                : {
                    id: 'business_entities',
                    itemsPerPage: 10,
                    currentPage: currentBePage,
                    totalItems: beTotal
                  }
          "
          [ngClass]="{ open: be.isOpened }"
        >
          <div class="be-entry">
            <div
              class="list-column business"
              [ngClass]="{ editing: be.nameEdition }"
            >
              <button
                type="button"
                class="far toggler-icon"
                [ngClass]="{
                  'fa-angle-down': !be.isOpened,
                  'fa-angle-up': be.isOpened
                }"
                *ngIf="be.request_count"
                (click)="be.isOpened = !be.isOpened"
              ></button>
              <button
                type="button"
                (click)="be.isOpened = !be.isOpened"
                *ngIf="!be.nameEdition"
              >
                {{ be.name }}
              </button>
              <button
                type="button"
                *ngIf="be.has_root_access && !be.nameEdition"
                class="far fa-pencil edit-be"
                (click)="startNameChange(be)"
              ></button>
              <input
                *ngIf="be.nameEdition"
                type="text"
                class="form-control"
                [(ngModel)]="be.name"
              />
              <button
                i18n="@@Save"
                *ngIf="be.nameEdition"
                (click)="confirmNameChangeModal(confirmNameChangeModalTemplate)"
                class="btn btn-primary btn-xs btn-green"
              >
                Save
              </button>
              <button
                i18n="@@Cancel"
                *ngIf="be.nameEdition"
                (click)="be.nameEdition = !be.nameEdition"
                class="btn btn-secondary btn-xs"
              >
                Cancel
              </button>
            </div>
            <div class="list-column number-files">
              {{ be.request_count }}
            </div>
            <div class="list-column date-column">
              {{ be.updated_at | date: DATETIME_FORMAT }}
            </div>
            <div class="list-column date-column">
              {{ be.created_at | date: DATETIME_FORMAT }}
            </div>
            <div class="list-column actions-column">
              <a
                [routerLink]="[
                  '/manage-business-entity',
                  be.business_entity_id
                ]"
                *ngIf="be.has_root_access"
                i18n-tooltip="@@Manage users"
                tooltip="Manage users"
                placement="top"
              >
                <i class="far fa-users-cog"></i>
                <span i18n="@@Manage users" class="responsive-label"
                  >Manage users</span
                >
              </a>
            </div>
          </div>
          <div class="be-file-list" [hidden]="!be.isOpened">
            <div class="header-content-separator"></div>
            <app-file-list
              [businessEntity]="be"
              [paginationId]="'business-entity-' + be.business_entity_id"
              [columns]="[
                AvailableFileListColumns.SERVICE_TITLE,
                AvailableFileListColumns.ENTERPRISE_NAME,
                AvailableFileListColumns.CREATED_AT,
                AvailableFileListColumns.STATUS
              ]"
            ></app-file-list>
          </div>
        </div>
      </div>
    </div>
    <pagination-controls
      class="list-pagination business"
      id="business_entities"
      [autoHide]="true"
      (pageChange)="onPageChange($event)"
      [previousLabel]="globalStateProviderService.previousLabel"
      [nextLabel]="globalStateProviderService.nextLabel"
    ></pagination-controls>
  </div>
</div>
<ng-template #confirmNameChangeModalTemplate>
  <div class="modal-header">
    <h4 i18n="@@Confirmation" class="modal-title pull-left">Confirmation</h4>
    <button
      type="button"
      class="btn-close close pull-right"
      aria-label="Close"
      (click)="bsModalRef?.hide()"
    >
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p
      i18n="
        @@This modification is considered <span
        class=&quot;strong&quot;>critical</span>. Please confirm the following
        change:"
      class="confirmation-modal-text"
    >
      This modification is considered <span class="strong">critical</span>.
      Please confirm the following change:
    </p>
    <div class="confirmation-modal-change-detail-container">
      <div class="orig-name">
        <h5 i18n="@@Original name" class="upper-text">Original name</h5>
        <span class="strong">{{ currentlyEdited?.originalName }}</span>
      </div>
      <div>
        <h5 i18n="@@New name" class="upper-text">New name</h5>
        <span class="strong">{{ currentlyEdited?.name }}</span>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      i18n="@@Confirm"
      type="button"
      class="btn btn-primary btn-red"
      (click)="confirmNameChange(); bsModalRef?.hide()"
    >
      Confirm
    </button>
    <button
      i18n="@@Cancel"
      type="button"
      class="btn btn-secondary"
      (click)="bsModalRef?.hide()"
    >
      Cancel
    </button>
  </div>
</ng-template>
